const currencyFormatter = Intl.NumberFormat("en-us", {
  style: "currency",
  currency: "USD",
});

export function formatCurrency(value: number): string {
  if (Number.isNaN(value)) return "";
  return currencyFormatter.format(value);
}

export function formatCurrencyWithoutDollar(value: number): string {
  return formatCurrency(value).replace("$", "");
}
